module.exports = __webpack_public_path__ + "static/media/googleReview.44cd367d.png";